import { Page } from 'ts/types/Page'
import {
  ButtonStyleAddPage,
  ClassAddPage,
  DenominationAddPage,
  LayoutAddPage,
  PaymentTypeAddPage,
  PriceLevelAddPage,
  ProductAddPage,
  ProductCategoryAddPage,
  SubClassAddPage,
  TaxAddPage,
  UserAddPage,
  UserTypeAddPage
} from 'pages/Main'

const routes: Page[] = [
  {
    routeName: '/button-style/add',
    component: ButtonStyleAddPage
  },
  {
    routeName: '/class/add',
    component: ClassAddPage
  },
  {
    routeName: '/denomination/add',
    component: DenominationAddPage
  },
  {
    routeName: '/layout/add',
    component: LayoutAddPage
  },
  {
    routeName: '/payment-type/add',
    component: PaymentTypeAddPage
  },
  {
    routeName: '/price-level/add',
    component: PriceLevelAddPage
  },
  {
    routeName: '/product/add',
    component: ProductAddPage
  },
  {
    routeName: '/sub-class/add',
    component: SubClassAddPage
  },
  {
    routeName: '/tax/add',
    component: TaxAddPage
  },
  {
    routeName: '/user/add',
    component: UserAddPage
  },
  {
    routeName: '/user-type/add',
    component: UserTypeAddPage
  },
  {
    routeName: '/product-category/add',
    component: ProductCategoryAddPage
  }
]

export default routes
